import { registerAction } from '../../Action'

const MARK_TASK_INCOMPLETE = 'MARK_TASK_INCOMPLETE'

const reducer = (state = {}, action) => {
  const subTab = [action.payload.subTab]
  const tasks = state.tasks[subTab]
  const itemIndex = tasks.findIndex(
    (item) => Number(item.id) === Number(action.payload.id)
  )

  if (itemIndex > -1) {
    const updatedTask = {
      ...tasks[itemIndex],
      status: 'pending',
    }
    tasks.splice(itemIndex, 1, updatedTask)

    return {
      ...state,
      tasks: {
        ...state.tasks,
        [subTab]: tasks,
      },
    }
  }
  return state
}

const markTaskIncomplete = registerAction(MARK_TASK_INCOMPLETE, { reducer })

export default markTaskIncomplete
